import NoSSR from "react-no-ssr";
import {C411Widget} from "./c411.widget";

type Props = { products: Product[]; category: Category; productsExisted: boolean };
export const Sidebar = ({ category, products, productsExisted }: Props) => (
  <div className='serp-sidebar'>
    <div className='related-search-container'>
      <NoSSR><div className="sidebar" data-s1search="sidebar" /></NoSSR>
    </div>
    <C411Widget products={products} category={category} productsExisted={productsExisted} />
  </div>
);

